import {defineStore, StoreState} from 'pinia'
import {fetchWrapper} from '@/helpers/fetchWrapper'
import router from '@/router/index'
import routes from "@/backendRoutes";
import backendRoutes from "@/backendRoutes";
import {Admin} from "@/interfaces/admin"
import {Keyable} from "@/types/keyable.type"
import {Student} from "@/interfaces/student";
import {Teacher} from "@/interfaces/teacher";
import {ContactPerson} from "@/interfaces/contactperson";
import { jwtDecode } from "jwt-decode";

function getCookie(name: string): string | undefined {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts?.pop()?.split(';').shift();
}

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => {
        return {
            user: localStorage.getItem('user') ? localStorage.getItem('user') : null,
        }
    },
    actions: {
        loadUser() {
            const jwtHp = getCookie('jwt_hp')
            if (jwtHp) {
                const jwtPayload = jwtDecode(jwtHp) as Keyable
                const user: Keyable = {
                    email: jwtPayload.username,
                    roles: jwtPayload.roles,
                    id: jwtPayload.id
                }
                if (jwtPayload.firstname) user['firstname'] = jwtPayload.firstname
                if (jwtPayload.name) user['name'] = jwtPayload.name
                this.user = JSON.stringify(user)
                localStorage.setItem('user', this.user)
            }
        },
        async login(email: string, password: string, entityType: string): Promise<void> {
            await fetchWrapper.post(routes.login, {email: email, password: password, entity_type: entityType})
            localStorage.removeItem('isImpersonating')
            this.loadUser()
        },
        logout(): void {
            this.user = null
            localStorage.removeItem('user')
            document.cookie = 'jwt_hp' + '=; Domain=' + (document.location.hostname === 'localhost' ? 'localhost' : '.dancecenter.be') + '; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            fetchWrapper.post(backendRoutes.logout)
            router.push({name: 'login'})
        },
        async checkCredentials(): Promise<void> {
            if (this.user) {
                await fetchWrapper.get(routes.check_auth).catch(() => {
                    this.logout()
                })
            }
        }
    },
    getters: {
        isLoggedIn(state: StoreState<Keyable>): boolean {
            return !!state.user
        },
        getUserType(state: StoreState<Keyable>): string | null {
            const user = JSON.parse(state.user)
            if (user && user.roles.includes('ROLE_ADMIN')) {
                return 'admin'
            } else if (user && user.roles.includes('ROLE_STUDENT')) {
                return 'student'
            } else if (user && user.roles.includes('ROLE_TEACHER')) {
                return 'teacher'
            } else if (user && user.roles.includes('ROLE_CONTACT_PERSON')) {
                return 'contact_person'
            } else {
                return null
            }
        },
        getUser(state: StoreState<Keyable>): Student | Admin | Teacher | ContactPerson | null {
            const user = JSON.parse(state.user)
            if (user && user.roles.includes('ROLE_ADMIN')) {
                return user as Admin
            } else if (user && user.roles.includes('ROLE_STUDENT')) {
                return user as Student
            } else if (user && user.roles.includes('ROLE_TEACHER')) {
                return user as Teacher
            } else if (user && user.roles.includes('ROLE_CONTACT_PERSON')) {
                return user as ContactPerson
            } else {
                return null
            }
        }
    }
})
